import { Box, Typography } from '@mui/material'

interface AnchorCTAProps {
  onScrollClick: () => void
}

export const AnchorCTA = ({ onScrollClick }: AnchorCTAProps) => (
  <Box sx={{ textAlign: 'center', py: 0.5 }}>
    <Typography
      component="span"
      variant="body2"
      onClick={onScrollClick}
      sx={{
        color: 'primary.dark',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': { color: 'primary.main' },
      }}
    >
      See how SIPP Pro acts on this data ↓
    </Typography>
  </Box>
)
